import axios from "../axios";

export type WorkBagSkill = {
  id: number;
  name: string;
};

export type WorkBagZone = {
  city: string;
};

export type WorkBagWorker = {
  id: number | string;
  name?: string;
  last_name?: string;
  phone?: string;
  email?: string;
  unemployment_fund?: boolean;
  employment_end_date?: string;
  jobBoardZones?: WorkBagZone[];
  skill?: Array<{ id?: number; skill?: { id?: number; name?: string } }>;
  [key: string]: any;
};

export type WorkBagFilterParams = {
  jurisdictions?: number[];
  skills?: number[];
};

const getAuthHeaders = () => {
  const token = localStorage.getItem("access-Token-Edify");
  if (!token) return {};
  return { headers: { Authorization: `Bearer ${token}` } };
};

const unwrapListPayload = <T>(payload: any): T[] => {
  if (Array.isArray(payload)) {
    if (payload.length === 0) return [];
    if (payload.length === 1 && Array.isArray(payload[0])) {
      return payload[0] as T[];
    }
    if (payload.length === 2) {
      if (Array.isArray(payload[0]) && typeof payload[1] === "number") {
        return payload[0] as T[];
      }
      if (Array.isArray(payload[1]) && typeof payload[0] === "number") {
        return payload[1] as T[];
      }
    }
    if (payload.every((item) => typeof item === "object")) {
      return payload as T[];
    }
  }
  return [];
};

export const workBagService = {
  fetchWorkers: async (): Promise<WorkBagWorker[]> => {
    const { data } = await axios.get("/bolsa-de-trabajo/all-registers", getAuthHeaders());
    return unwrapListPayload<WorkBagWorker>(data);
  },

  filterWorkers: async (params: WorkBagFilterParams): Promise<WorkBagWorker[]> => {
    const searchParams = new URLSearchParams();
    params.jurisdictions?.forEach((id) => searchParams.append("jurisdicciones", String(id)));
    params.skills?.forEach((id) => searchParams.append("skills", String(id)));
    const query = searchParams.toString();
    const url = query ? `/bolsa-de-trabajo/get/getByFilter?${query}` : "/bolsa-de-trabajo/get/getByFilter";
    const { data } = await axios.get(url, getAuthHeaders());
    return unwrapListPayload<WorkBagWorker>(data);
  },

  filterWorkersByParams: async (params: {
    jurisdictions?: number[];
    cities?: string[];
    skills?: number[];
    identityValidated?: boolean;
  }): Promise<WorkBagWorker[]> => {
    const searchParams = new URLSearchParams();
    params.jurisdictions?.forEach((id) => searchParams.append("jurisdicciones", String(id)));
    params.cities?.forEach((city) => searchParams.append("cities", city));
    params.skills?.forEach((id) => searchParams.append("skills", String(id)));
    if (typeof params.identityValidated === "boolean") {
      searchParams.append("identity_validated", params.identityValidated ? "true" : "false");
    }
    const query = searchParams.toString();
    const url = query ? `/bolsa-de-trabajo/get/getByFilter?${query}` : "/bolsa-de-trabajo/get/getByFilter";
    const { data } = await axios.get(url, getAuthHeaders());
    return unwrapListPayload<WorkBagWorker>(data);
  },

  fetchSkills: async (): Promise<WorkBagSkill[]> => {
    const { data } = await axios.get("/skill/AllUsers", getAuthHeaders());
    const raw = data?.response?.results ?? data ?? [];
    const list = unwrapListPayload<WorkBagSkill>(raw);
    return [...list].sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
  },
};
